import React from "react";
const BeautyPage = () => {
  const openNearestStoreMap = () => {
    const mapsUrl =
      "https://www.google.com/maps/search/?api=1&query=Shree%20Prem%20Cosmetics%2C%20Indore%2C%20Madhya%20Pradesh";
    window.open(mapsUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="bg-[#F5EAEA] min-h-[900px] flex flex-col items-center p-4 lg:pt-40 md:p-8">
      {/* Main Content */}
      <main className="flex flex-col-reverse lg:flex-row items-center justify-around px-4 md:px-8 w-full max-w-8xl gap-6 md:gap-10 mt-16 md:mt-20 lg:mt-8">
        {/* Text Content */}
        <div className="flex flex-col max-md:mt-10 items-start text-left w-full lg:mt-0 pl-0">
          <h1 className="text-2xl lg:text-[65px] max-md:text-[40px] font-semibold text-gray-800 leading-snug break-words">
            Step into a world where beauty knows no bounds
          </h1>
          <p className="text-lg text-gray-600 mt-4 max-md:mr-24 break-words">
            Get Best brands at best prices
          </p>
          {/* Call to Action */}
          <div className="flex flex-col max-md:mt-24 mt-8 lg:ml-3 w-fit">
            <h2 className="text-md max-md:text-xl max-md:font-semibold lg:text-center lg:mt-6 text-[2.5vh] text-[#575757]">
              Download the App now
            </h2>
            <div className="flex flex-wrap items-center mt-3 gap-3">
              <a
                href="https://play.google.com/store/apps/details?id=com.medusa.spc.android&hl=en"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Google Play"
                className="w-[48%] object-cover h-[60px]"
              >
                <img
                  src="/assets/playstore.svg"
                  alt="Google Play"
                  className="cursor-pointer w-full h-full"
                />
              </a>
              <a
                href="https://apps.apple.com/in/app/shree-prem-cosmetics/id6692621340"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="App Store"
                className="w-[44%] object-cover h-[60px] py-1"
              >
                <img
                  src="https://storage.googleapis.com/spc-prod-infra-spc-assets/spc-website-assets/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917%201.svg"
                  alt="App Store"
                  className="cursor-pointer  w-full"
                />
              </a>
            </div>
            <p className="text-gray-500 text-lg text-center">or</p>
            <button
              type="button"
              onClick={openNearestStoreMap}
              className="bg-transparent text-gray-700 border border-black py-2 px-4 rounded-md mt-1 lg:w-full max-md:w-[350px] shadow-sm"
            >
              Visit your nearest Store
            </button>
          </div>
        </div>
        {/* Image Grid */}
        <div className="w-full max-md:pr-4 max-md:w-[400px] mt-14 lg:mt-0">
          <div className="grid grid-cols-1 max-md:mt-14  lg:w-[800px] max-md:grid-cols-3 sm:grid-cols-3 max-md:gap-2 gap-6">
            <img
              src="https://storage.googleapis.com/spc-prod-infra-spc-assets/spc-website-assets/Frame%201261154371.jpg"
              alt="Makeup"
              className="w-full h-auto max-w-full md:max-w-sm lg:max-w-md shadow-lg"
            />
            <img
              src="https://storage.googleapis.com/spc-prod-infra-spc-assets/spc-website-assets/Frame%201261154372.jpg"
              alt="Flowers"
              className="w-full h-auto max-w-full md:max-w-sm lg:max-w-md shadow-lg max-md:-translate-y-12 sm:transform sm:-translate-y-16"
            />
            <img
              src="https://storage.googleapis.com/spc-prod-infra-spc-assets/spc-website-assets/Frame%201261154373.jpg"
              alt="Lipstick"
              className="w-full h-auto max-w-full md:max-w-sm lg:max-w-md shadow-lg"
            />
          </div>
        </div>
      </main>
    </div>
  );
};
export default BeautyPage;
